<div>
  <div class="row select__wrapper">
    <div class="select">
      <div class="input-label-container">
        <input
          class="select__input"
          [class.select__input--disabled]="isDisabled"
          #selectInput
          [ngModel]="showSelectedItem ? selectedItem : null"
          id="{{ componentId }}"
          readonly
          (keyup)="keyUpPress($event)"
          (keydown)="keyDownPress($event)"
          (blur)="onblur()"
          [placeholder]="placeholder ? placeholder : 'Select'"
          [class.select--error__input]="isError"
          [class.select--label]="label"
          [disabled]="isDisabled"
        />
        <label
          *ngIf="label"
          class="entry-field__label"
          for="{{ componentId }}"
          [class.entry-field--error__label]="isError"
          [class.entry-field--filled__label]="!isError && !!selectedItem"
        >
          {{ label }}
        </label>
      </div>
      <ul
        *ngIf="showDropdown"
        #dropdownUl
        class="select__box"
        [ngClass]="getClasses()"
        [class.select__box--label]="label"
      >
        <li
          class="select__item"
          *ngFor="let option of options; let i = index"
          [class.select__item--selected]="i === selectedIndex"
          [class.select__item--disabled]="invalidOptions.indexOf(option.value) >= 0"
          (click)="trigger(option)"
        >
          {{ option.description }}
        </li>
      </ul>
    </div>

    <p class="error-message error-message--entry-field" *ngIf="isError">
      {{ errorMessage[prop] }}
    </p>
  </div>
</div>
